import { useNavigate } from "react-router-dom";
const WsrButton = ({ handleCaptureAndAddToPpt }) => {
  const navigate = useNavigate();
  return (
    <section className="flex justify-center mt-5 gap-5">
      <button
        className="bg-[#2A5775] text-sm text-nowrap h-10 text-white font-semibold py-1 px-4 rounded hover:bg-[#2898e2] focus:outline-none focus:ring-2 focus:ring-blue-300 transition-all duration-300"
        onClick={handleCaptureAndAddToPpt}
        title="Capture screenshot to add to PowerPoint"
      >
        Capture Screenshot
      </button>
      <button
        className="bg-[#2A5775] text-sm text-nowrap h-10 text-white font-semibold py-1 px-4 rounded hover:bg-[#2898e2] focus:outline-none focus:ring-2 focus:ring-blue-300 transition-all duration-300"
        title="Performance Dashboard"
        onClick={() => navigate("/Performance-Dashboard")}
      >
        Performance
      </button>
      <button
        className="bg-[#2A5775] text-sm text-nowrap h-10 text-white font-semibold py-1 px-4 rounded hover:bg-[#2898e2] focus:outline-none focus:ring-2 focus:ring-blue-300 transition-all duration-300"
        title="Weekly Sales Review"
        onClick={() => navigate("/WSR")}
      >
        Weekly Sales Review
      </button>
      <button
        className="bg-[#2A5775] text-sm text-nowrap h-10 text-white font-semibold py-1 px-4 rounded hover:bg-[#2898e2] focus:outline-none focus:ring-2 focus:ring-blue-300 transition-all duration-300"
        title="Top 5 Applications TQP"
        onClick={() => navigate("/Tqp-LostCase")}
      >
        Top 5 Applications TQP
      </button>
      <button
        className="bg-[#2A5775] text-sm text-nowrap h-10 text-white font-semibold py-1 px-4 rounded hover:bg-[#2898e2] focus:outline-none focus:ring-2 focus:ring-blue-300 transition-all duration-300"
        title="WSR-Metrics"
        onClick={() => navigate("/WSR-Metrics")}
      >
        Metrics
      </button>
      <button
        className="bg-[#2A5775] text-sm text-nowrap h-10 text-white font-semibold py-1 px-4 rounded hover:bg-[#2898e2] focus:outline-none focus:ring-2 focus:ring-blue-300 transition-all duration-300"
        title="State wise Analysis of Retail & Offtake"
        onClick={() => navigate("/State-Offtake-Retails")}
      >
        State wise Analysis of Retail & Offtake
      </button>
    </section>
  );
};

export default WsrButton;
